import commBaseCodeManage from './commBaseCodeManage'
export default commBaseCodeManage
